module.exports = __webpack_public_path__ + "static/media/performance-essay.fb2c5f1b.svg";